import { styled } from "@mui/material/styles";

import type { CSSProperties } from "react";

export const ThreadPreviewList = styled("ul")({
	width: "100%",
	padding: 0,
	paddingBottom: 5,
	margin: 0,
	display: "flex",
	flexDirection: "column",
	gap: 5,
	listStyle: "none",
});

export const ThreadPreviewListItem = styled("li")({
	height: "fit-content",
	padding: 2,
	margin: 0,
	borderRadius: 8,
	border: "1px solid #E3E4F0",
});

export const ThreadPreviewButton = styled("button")<{
	isFailedStatus?: boolean;
	isEmptyMessage?: boolean;
}>(({ isFailedStatus, isEmptyMessage }) => ({
	height: "100%",
	width: "100%",
	padding: 8,
	border: "none",
	borderRadius: "inherit",
	backgroundColor: "inherit",
	color: "var(--inhouse-primary-dark)",

	display: "grid",
	gridTemplateRows: isFailedStatus ? `repeat(${isEmptyMessage ? 2 : 3}, 1fr)` : `repeat(${isEmptyMessage ? 1 : 2}, 1fr)`,
	gridTemplateColumns: "repeat(2, 1fr)",
	alignItems: "center",

	cursor: "pointer",
	rowGap: !isFailedStatus && isEmptyMessage ? 0 : "6px",
}));

export const ThreadMessageTypography = styled("p")<{ isError?: boolean }>(({ isError }) => ({
	overflow: "hidden",
	whiteSpace: "nowrap",
	textOverflow: "ellipsis",
	fontWeight: 400,
	fontSize: "12px",
	margin: 0,
	color: isError ? "#E71C00" : "var(--inhouse-primary-dark)",
	lineHeight: "100%",
}));

export const ThreadMessageListSection = styled("section")({
	width: "100%",
	backgroundColor: "var(--inhouse-primary-alpha-08)",
	boxShadow: "-8px 0px 8px 0px #7671A426",
});

export const ThreadMessageList = styled("ol")(() => ({
	listStyle: "none",
	margin: 0,
	marginTop: 10,
	marginBottom: 10,
	padding: 0,
	width: "100%",
	height: "fit-content",
	display: "flex",
	flexDirection: "column",
	gap: 10,
	overflow: "auto",
}));

export type SentFromType = "user" | "server" | "admin";

export const getMessageBubbleStyle = (sentFrom: SentFromType): CSSProperties => ({
	width: "75%",
	padding: 8,
	marginLeft: 19,
	marginRight: 19,
	borderRadius: 8,
	boxShadow: "0px 1px 1px 0px #0000001A",
	backgroundColor: sentFrom === "user" ? "#ffffff" : sentFrom === "admin" ? "#E8E5F7" : "#F1F3F9",
	alignSelf: sentFrom === "user" ? "flex-start" : "flex-end",

	fontSize: 14,
	color: "var(--inhouse-primary-dark)",
	letterSpacing: 0,
	lineHeight: "19px",

	display: "flex",
	flexDirection: "column",
	gap: 5,
});

export const ThreadMessageListItem = styled("li")<{
	sentFrom: SentFromType;
}>(({ sentFrom = "user" }) => ({
	...getMessageBubbleStyle(sentFrom),
}));

export const ThreadMessageHeader = styled("header")({
	width: "100%",
	display: "flex",
	gap: 10,
	alignItems: "center",
	fontSize: 14,
	fontWeight: 600,
	color: "var(--inhouse-primary-dark)",
});

export const NewThreadMessageDiv = styled("div")({
	...getMessageBubbleStyle("admin"),
	marginRight: "4px",
});

export const ThreadMessagesRootDiv = styled("div")({
	height: "calc(100% - 10px)",
	display: "flex",
	flexDirection: "column",
	gap: 5,
});

export const ThreadMessagesListDiv = styled("div")({
	maxHeight: "100%",
	display: "flex",
	flexDirection: "column",
	height: "calc(100% - 40px)",
});

export const NewMessageRootDiv = styled("div")({
	display: "flex",
	justifyContent: "end",
	alignItems: "center",
});
